import React, { useEffect, useState } from 'react';
import {
  Form,
  Input,
  Button,
  Select,
  Cascader,
  Typography,
  Col,
  Row,
  Tooltip,
} from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';
import styles from '../../../../shared-components/Recipe/recipe.module.sass';
import { default as threat_detail_styles } from '../../../HomeContainer/components/Home/threat-detail.module.sass';
import moment from 'moment-timezone';
import store from '../../../../redux/store';
import mixpanel from 'mixpanel-browser';
import history from '../../../../redux/history';
import VersionCheck from '../../../../shared-components/VersionCheck';
import { STATUS } from '../../../../redux/constants';
import { changeTitle } from '../../../../redux/actions/app';
import { useDispatch } from 'react-redux';
import SavedRecipeModal from '../../../../shared-components/SavedRecipeModal';
import useModalNameValidator from '../../../../redux/utils/useModalNameValidator';
import PermissionDeniedPage from '../../../../shared-components/PermissionDeniedPage';
import { highlightLeftMenu } from '../../../../redux/actions/leftMenu';
import { Link } from 'react-router-dom';
import LoadingSilentPush from '../../../../shared-components/LoadingSilentPush';
import { validateRecipeDomainName } from '../../../../shared-components/Validation/RecipeDomainName';

function NameInTXTQuery(props) {
  mixpanel.track('Global Nav - Name in TXT Record', {
    location: window.location.href,
  });
  // const { exploreRecipe } = props;

  function useQuery() {
    return new URLSearchParams(window.location.search);
  }

  const q = useQuery();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [nameOfNewQuery, setNameOfNewQuery] = useState('');
  const [descriptionOfNewQuery, setDescriptionOfNewQuery] = useState('');
  const [saveModalType, setSaveModalType] = useState('saveNew');
  const isSaveModalValid = useModalNameValidator(nameOfNewQuery);
  const { Text, Paragraph, Title } = Typography;

  const options = [
    {
      value: 'first_seen',
      label: 'First Seen',
      children: [
        {
          value: 'asc',
          label: 'Ascending',
        },
        {
          value: 'desc',
          label: 'Descending',
        },
      ],
    },
    {
      value: 'last_seen',
      label: 'Last Seen',
      children: [
        {
          value: 'asc',
          label: 'Ascending',
        },
        {
          value: 'desc',
          label: 'Descending',
        },
      ],
    },
    {
      value: 'query',
      label: 'Query',
      children: [
        {
          value: 'asc',
          label: 'Ascending',
        },
        {
          value: 'desc',
          label: 'Descending',
        },
      ],
    },
    {
      value: 'answer',
      label: 'Answer',
      children: [
        {
          value: 'asc',
          label: 'Ascending',
        },
        {
          value: 'desc',
          label: 'Descending',
        },
      ],
    },
  ];

  const titleText = q?.get('left_menu_name') || 'Name in TXT Record';

  useEffect(() => {
    document.title = `${titleText} - Silent Push`;
    props.loadUser();
    props.loadMySubscriptionPlan();
    props.resetRecipeStatus();
    props.clearExploreDetails();
    form.resetFields();

    if (q?.get('recipeid')) {
      //load specific recipe
      props.loadMergeAPIExploreRecipeNameInTXT(q?.get('recipeid'));
    }
    dispatch(changeTitle(titleText, null));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    props.resetRecipeStatus();
    form.resetFields();
    setSaveModalType('saveNew');

    if (q?.get('recipeid')) {
      //load specific recipe
      props.loadMergeAPIExploreRecipeNameInTXT(q?.get('recipeid'));
    }
  }, [window.location.search]); // eslint-disable-line react-hooks/exhaustive-deps

  function resetForm() {
    form.resetFields();
    if (q?.get('recipeid')) {
      props.loadMergeAPIExploreRecipeNameInTXT(q?.get('recipeid'));
    }
  }

  useEffect(() => {
    form.resetFields();
    dispatch(
      changeTitle(props.exploreRecipeNameInTXT?.name ?? titleText, null),
    );
    document.title = `${titleText} - Silent Push`;
    if (
      props.recipeStatusNameInTXT == STATUS.LOADED &&
      props.exploreRecipeNameInTXT?.name
    ) {
      document.title = `${props.exploreRecipeNameInTXT?.name} - Silent Push`;
    }
    // }, [props.exploreRecipeNameInTXT]); // eslint-disable-line react-hooks/exhaustive-deps

    // useEffect(() => {
    if (window.location.href.includes('/explore/name-in-txt')) {
      if (
        props.exploreRecipeNameInTXT?.uuid &&
        window.location.href.indexOf(
          '/explore/name-in-txt?recipeid=' + props.exploreRecipeNameInTXT?.uuid,
        ) == -1
      ) {
        history.push(
          '/explore/name-in-txt?recipeid=' + props.exploreRecipeNameInTXT?.uuid,
        );
        dispatch(highlightLeftMenu(props.exploreRecipeNameInTXT?.uuid));
      }
      form.resetFields();
      form.setFieldsValue({
        threat_name: props.exploreRecipeNameInTXT?.domain,
        window: props.exploreRecipeNameInTXT?.window,
        limit:
          props.exploreRecipeNameInTXT?.limit === 100
            ? ''
            : props.exploreRecipeNameInTXT?.limit,
        sort: props.exploreRecipeNameInTXT?.sort_by
          ? [
              props.exploreRecipeNameInTXT?.sort_by,
              props.exploreRecipeNameInTXT?.order_by,
            ]
          : null,
      });
    }
  }, [props.exploreRecipeNameInTXT]);

  const handleCancel = () => {
    setNameOfNewQuery('');
    setDescriptionOfNewQuery('');
    setIsModalVisible(false);
  };

  function changeScopeRecipe() {
    props.changeScopeMergeAPIExploreRecipeNameInTXT({
      scope:
        props.exploreRecipeNameInTXT?.scope === 'USER'
          ? 'ORGANISATION'
          : 'USER',
      uuid: props.exploreRecipeNameInTXT?.uuid,
    });
  }

  function returnUiRecipeData(values, type) {
    if (type === 'saveAs') {
      return {
        new_name: nameOfNewQuery
          ? nameOfNewQuery
          : props.exploreRecipeNameInTXT?.name,
        new_description:
          descriptionOfNewQuery || descriptionOfNewQuery === ''
            ? descriptionOfNewQuery
            : props.exploreRecipeNameInTXT?.description,
      };
    } else {
      return {
        name: nameOfNewQuery
          ? nameOfNewQuery
          : props.exploreRecipeNameInTXT?.name,
        description:
          descriptionOfNewQuery || descriptionOfNewQuery === ''
            ? descriptionOfNewQuery
            : props.exploreRecipeNameInTXT?.description,
        domain: values?.threat_name
          .replace('http://', '')
          .replace('https://', '')
          .replace('www.', '')
          .replace('[', '')
          .replace(']', '')
          .replace(' ', '')
          .trim(),
        window: values?.window ? values.window : '14',
        limit: values?.limit ? values?.limit : 100,
        order_by: values?.sort?.length > 0 ? values?.sort[1] : null,
        sort_by: values?.sort?.length > 0 ? values?.sort[0] : null,
        uuid: q?.get('recipeid'),
      };
    }
  }

  const handleOk = (type) => {
    form
      .validateFields()
      .then((values) => {
        if (saveModalType === 'edit' || type === 'edit') {
          props.updateMergeAPIExploreRecipeNameInTXT(
            returnUiRecipeData(values, type),
          );
        } else if (saveModalType === 'saveNew' || type === 'saveNew') {
          props.saveMergeAPIExploreRecipeNameInTXT(
            returnUiRecipeData(values, type),
          );
        } else if (saveModalType === 'saveAs' || type === 'saveAs') {
          props.cloneRecipe(
            returnUiRecipeData(values, type),
            'name-in-txt-recipes',
            q?.get('recipeid'),
          );
        }
      })
      .catch((errorInfo) => {
        console.log(errorInfo);
      });
    setNameOfNewQuery('');
    setDescriptionOfNewQuery('');
    setIsModalVisible(false);
  };

  function renderPane() {
    return props.mySubscriptionPlanStatus === STATUS.LOADED ? (
      props.mySubscriptionPlan?.has_access_to_name_in_txt_recipe ? (
        props.recipeStatusNameInTXT !== STATUS.LOADING ? (
          <div className={styles.explore_recipe}>
            <Row gutter={24}>
              <Col xs={24} className={styles.header}>
                <div className={threat_detail_styles['type-chip']}>
                  {titleText}
                </div>

                <div className={styles.recipeDescription}>
                  <Paragraph className="m-0">
                    {props.exploreRecipeNameInTXT?.description
                      ? props.exploreRecipeNameInTXT.description
                      : 'Get a list of TXT records that reference your domain.'}{' '}
                  </Paragraph>

                  <Link
                    to={{
                      pathname:
                        'https://help.silentpush.com/docs/scan-for-unauthorised-email-servers',
                    }}
                    target="_blank"
                  >
                    Knowledge Base
                  </Link>
                </div>

                <div className={styles.action_buttons}>
                  {((q?.get('recipeid') &&
                    props.exploreRecipeNameInTXT?.scope === 'USER') ||
                    (q?.get('recipeid') &&
                      props.exploreRecipeNameInTXT?.scope === 'ORGANISATION' &&
                      props.exploreRecipeNameInTXT?.is_mine === true)) && (
                    <>
                      <Tooltip
                        title={
                          props.mySubscriptionPlan
                            ?.has_access_to_share_unshare ? (
                            ''
                          ) : (
                            <>
                              Sharing option is not part of this subscription
                              plan. To upgrade your subscription contact us at{' '}
                              <a
                                target="_blank"
                                href="mailto:sales@silentpush.com"
                              >
                                sales@silentpush.com
                              </a>
                              .
                            </>
                          )
                        }
                      >
                        <Button
                          disabled={
                            !props.mySubscriptionPlan
                              ?.has_access_to_share_unshare
                          }
                          role={'button1'}
                          onClick={() => changeScopeRecipe()}
                        >
                          {props.exploreRecipeNameInTXT?.scope ===
                          'ORGANISATION'
                            ? 'Unshare'
                            : 'Share'}
                        </Button>
                      </Tooltip>

                      <Button
                        onClick={() => {
                          setSaveModalType('edit');
                          setIsModalVisible(true);
                        }}
                      >
                        Edit
                      </Button>

                      <Button
                        danger
                        onClick={() => {
                          props.deleteMergeAPIExploreRecipeNameInTXT(
                            q?.get('recipeid'),
                          );
                          props.resetRecipeStatus();
                          props.clearExploreDetails();
                          props.history.push('/explore');
                        }}
                      >
                        Delete
                      </Button>
                    </>
                  )}
                </div>
              </Col>
            </Row>

            <Form
              className={styles.form}
              form={form}
              name="explore"
              initialValues={{
                threat_name: props.exploreRecipeNameInTXT.domain,
                window: props.exploreRecipeNameInTXT.window,
                limit:
                  props.exploreRecipeNameInTXT.limit === 100
                    ? ''
                    : props.exploreRecipeNameInTXT.limit,
                sort: props.exploreRecipeNameInTXT.sort_by
                  ? [
                      props.exploreRecipeNameInTXT.sort_by,
                      props.exploreRecipeNameInTXT.order_by,
                    ]
                  : null,
              }}
              onFinish={(values) => {
                /*
                We need to use absolute timestamps since some domains like
                'facebook' have a high rate of new records every second.
                !!!DON'T USE RELATIVE TIMESTAMPS!!!
                 */
                const last_seen_after_14days_ago = moment()
                  .utc()
                  .set('hour', 0)
                  .set('minute', 0)
                  .set('second', 0)
                  .set('millisecond', 0)
                  .subtract(14, 'days')
                  .unix();
                const last_seen_before_today_midnight = moment()
                  .utc()
                  .set('hour', 0)
                  .set('minute', 0)
                  .set('second', 0)
                  .set('millisecond', 0)
                  .unix();
                props.history.push(
                  `/explore-result?name=${
                    values.threat_name
                      .replace('http://', '')
                      .replace('https://', '')
                      .replace('www.', '')
                      .replace('[', '')
                      .replace(']', '')
                      .replace(' ', '')
                      .trim()
                      .split(/\.(?=[^\.]+$)/)?.[0]
                  }*&queryType=nameintxt&type=TXT` +
                    `&last_seen_after=${last_seen_after_14days_ago}` +
                    `&last_seen_before=${last_seen_before_today_midnight}` +
                    (values.limit ? `&limit=${values.limit}` : '') +
                    (values?.sort?.length > 0
                      ? `&sort=${values?.sort[0]}/${values?.sort[1]}`
                      : '') +
                    '&origin_uid=NAME_IN_TXT&recipe=/explore/name-in-txt' +
                    ((q?.get('recipeid')
                      ? `?recipeid=${q?.get('recipeid')}`
                      : '') ?? '') +
                    '&backLink=' +
                    encodeURIComponent(window.location.pathname) +
                    encodeURIComponent(window.location.search),
                );
              }}
            >
              <Row gutter={36}>
                <Col xs={24} lg={12}>
                  <Title level={5}>Domain *</Title>

                  <Text>Domain Name</Text>
                  <Form.Item
                    name="threat_name"
                    rules={[
                      ({ getFieldValue }) => ({
                        validator(fieldObject, fieldValue) {
                          const validation = validateRecipeDomainName(
                            fieldValue,
                            titleText,
                          );

                          if (validation.valid) {
                            return Promise.resolve();
                          } else {
                            return Promise.reject(validation?.message);
                          }
                        },
                      }),
                    ]}
                  >
                    <Input placeholder="Enter Domain Name" />
                  </Form.Item>
                </Col>

                <Col xs={24} lg={12}></Col>

                <Col xs={24} lg={12}>
                  <Title level={5}>Last Seen</Title>

                  <Text>
                    Period{' '}
                    <Tooltip
                      placement="top"
                      title="Only show records last observed in the selected period. (optional)"
                    >
                      <InfoCircleFilled />
                    </Tooltip>
                  </Text>
                  <Form.Item
                    name="window"
                    rules={[
                      {
                        required: false,
                        message: 'Please input the window!',
                      },
                    ]}
                  >
                    <Select
                      options={[{ label: '14 days', value: '14' }]}
                      defaultValue="14"
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} lg={12}>
                  <Title level={5}>Sorting</Title>

                  <Text>Sort/Order</Text>
                  <Form.Item name="sort">
                    <Cascader options={options} placeholder="Sort/Order" />
                  </Form.Item>
                </Col>
              </Row>

              <div className={styles.bottom_actions}>
                <Form.Item>
                  <Tooltip
                    title={
                      props.mySubscriptionPlan?.has_access_to_explore ? (
                        ''
                      ) : (
                        <>
                          This option is not part of this subscription plan. To
                          upgrade your subscription contact us at{' '}
                          <a target="_blank" href="mailto:sales@silentpush.com">
                            sales@silentpush.com
                          </a>
                          .
                        </>
                      )
                    }
                  >
                    <Button
                      disabled={
                        !props.mySubscriptionPlan?.has_access_to_explore
                      }
                      role={'button2'}
                      type="primary"
                      htmlType="submit"
                    >
                      Search
                    </Button>
                  </Tooltip>
                </Form.Item>

                <Button
                  role={'button1'}
                  onClick={() => {
                    if (saveModalType === 'saveNew' && !q?.get('recipeid')) {
                      form
                        .validateFields()
                        .then((values) => {
                          setNameOfNewQuery('');
                          setDescriptionOfNewQuery('');
                          setSaveModalType('saveNew');
                          setIsModalVisible(true);
                        })
                        .catch((errorInfo) => {});
                    } else {
                      handleOk('edit');
                    }
                  }}
                >
                  {q?.get('recipeid') ? 'Update Recipe' : 'Save Recipe'}
                </Button>

                {q?.get('recipeid') && (
                  <Button
                    role={'button3'}
                    onClick={() => {
                      setSaveModalType('saveAs');
                      setIsModalVisible(true);
                    }}
                  >
                    Save As
                  </Button>
                )}

                <Button className="ms-05" onClick={() => resetForm()}>
                  Reset Form
                </Button>
              </div>
            </Form>
          </div>
        ) : (
          <LoadingSilentPush size={80} positionCenter />
        )
      ) : (
        <PermissionDeniedPage />
      )
    ) : (
      <LoadingSilentPush size={80} positionCenter />
    );
  }

  return (
    <>
      <SavedRecipeModal
        isModalVisible={isModalVisible}
        isSaveModalValid={isSaveModalValid}
        handleOk={handleOk}
        handleCancel={handleCancel}
        nameOfNewQuery={nameOfNewQuery}
        setNameOfNewQuery={setNameOfNewQuery}
        descriptionOfNewQuery={descriptionOfNewQuery}
        setDescriptionOfNewQuery={setDescriptionOfNewQuery}
        type={saveModalType}
        loadedRecipe={props.exploreRecipeNameInTXT}
      />
      {renderPane()}
      <VersionCheck
        parentComponentStatus={
          q?.get('recipeid') ? props.recipeStatusNameInTXT : STATUS.LOADED
        }
      />
    </>
  );
}

export default NameInTXTQuery;
